export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  NOTIFICATION_PAGE: "notification-page",
  SEARCH_PAGE: "search-page",
  SAVED_PAGE: "saved-page",
  STORY_PAGE: "story-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  AUTHOR_PAGE: "author-page",
  POLL_COUNTER_PAGE: "poll-counter-page",
  UGC_PAGE: "ugc-page",
});

// these are the sections required to generate routes for the deleted sections and handle redirections
export const DELETED_SECTION_ROUTES = [
  "গোলটেবিল",
  "gadget",
  "travel",
  "photo",
  "opinion",
  "singapore",
  "middle-east",
  "malaysia",
  "japan",
  "india",
  "europe",
  "china",
  "canada",
  "australia",
  "impact-journalism",
  "primary-and-secondary-education",
  "uk",
  "demo-like-home-author",
  "demo-like-home-tag",
  "demo-like-home-5",
  "demo-like-home-3",
  "technology",
  "socialmedia",
  "gallery",
  "itnews",
  "advice",
  "freelancing",
  "smart-somoy",
  "amader-kotha-shono",
  "roshalo",
  "alokito-chattogram",
  "sabar-age-shisu",
  "projonmo-dot-com",
  "cholti-bishow",
  "shilpo-o-sahitto",
  "anna-alo",
  "22221",
  "feature",
  "history",
  "olympic",
  "gallery",
  "science",
  "subeditorial",
  "video",
  "news",
  "ayojon",
  "nagorik-sangbad",
  "available",
  "other",
  "gallery",
  "occupation",
  "horoscope",
  "recipe",
  "jenenin",
  "home-decoration",
  "advice",
  "beautification",
  "style",
  "fashion",
  "gallery",
  "north-america",
  "australia",
  "arab-world",
  "tarunno",
  "chakri-bakri",
  "special-supplement",
  "pachmisheli",
  "we-are",
  "features",
  "review",
  "gallery",
  "cinema",
  "web",
  "higher-secondary-education",
  "budget",
  "corporate",
  "private-sector",
  "financial",
  "garments",
  "business",
  "america",
  "africa",
  "durporobash",
  "gallery",
  "government",
  "politics",
];
